export const environment = {
  production: false,
  envName: 'QA',
  keycloak: {
    url: 'https://auth-qa.aguapotableplottier.com.ar',
    realm: 'CooperativaAguaPlottier',
    clientId: 'sgcap-stock'
  },
  apiUrl: '/api',
};
